import { MenuItemInterface } from '@vs/ui/portal/menu';
import { DeployEnv } from '@vs/utils/envConfig';

import { deployEnv, isLocalDevMode } from '..';
import { ManagementTypes } from '../../redux/slices/global';
import corePaths from './corePaths';
import dmPaths from './dmPaths';
import systemPaths from './systemPaths';

type LazyView =
  | React.LazyExoticComponent<() => JSX.Element>
  | React.LazyExoticComponent<React.MemoExoticComponent<() => JSX.Element>>;

export type Path = MenuItemInterface<{
  path: string;
  View?: LazyView;
  activeEnv?: DeployEnv[];
  /** 子頁的返回鍵回到父頁時帶上的 hash（父頁用 hash 切分頁時用） */
  backHash?: string;
}>;

const getActivePaths = (paths: Path[], opts?: { getAll?: boolean }): Path[] => {
  return paths
    .filter(
      ({ activeEnv }) =>
        opts?.getAll ||
        !activeEnv ||
        activeEnv.includes(deployEnv) ||
        isLocalDevMode
    )
    .map(path => ({
      ...path,
      childViews: path.childViews
        ? getActivePaths(path.childViews, opts)
        : undefined,
    }));
};

const flatPaths = (paths: Path[], parentPath: Path['path']): Path[] => {
  const result: Path[] = [];

  for (const path of paths) {
    const pathForNavigation = `${parentPath}${path.path}`;

    result.push({
      ...path,
      path: pathForNavigation,
    });

    if (path.childViews) {
      result.push(...flatPaths(path.childViews, pathForNavigation));
    }
  }

  return result;
};

type PathConfigs = {
  [key in ManagementTypes]?: Path[];
};

const pathConfigs: PathConfigs = {
  core: corePaths,
  system: systemPaths,
  dm: dmPaths,
};

export const getPathConfigs = (
  managementType: ManagementTypes,
  { flat, getAll }: { flat?: boolean; getAll?: boolean } = {}
): Path[] => {
  const paths = getActivePaths(pathConfigs[managementType] ?? [], {
    getAll,
  });

  if (!flat) return paths;

  return flatPaths(paths, '');
};
